<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import DropdownBody from 'next/dropdown-menu/base/DropdownBody.vue';

const emit = defineEmits(['executeCopilotAction']);

const { t } = useI18n();

// SuperTVGo: menu fixo com só as 4 ações do Copilot deste negócio — substitui
// o menu genérico de tom/gramática/melhorar/ask-copilot do Chatwoot padrão.
const menuItems = computed(() => [
  {
    label: t('INTEGRATION_SETTINGS.OPEN_AI.REPLY_OPTIONS.SUGGEST_REPLY'),
    key: 'suggest_reply',
    icon: 'i-fluent-chat-sparkle-16-regular',
  },
  {
    label: t('INTEGRATION_SETTINGS.OPEN_AI.REPLY_OPTIONS.GUIDED_REPLY'),
    key: 'guided_reply',
    icon: 'i-fluent-pen-sparkle-24-regular',
  },
  {
    label: t('INTEGRATION_SETTINGS.OPEN_AI.REPLY_OPTIONS.SUMMARIZE_AND_POST'),
    key: 'summarize_and_post',
    icon: 'i-fluent-text-bullet-list-square-sparkle-32-regular',
  },
  {
    label: t('INTEGRATION_SETTINGS.OPEN_AI.REPLY_OPTIONS.CUSTOMER_CONTEXT'),
    key: 'customer_context',
    icon: 'i-fluent-person-search-24-regular',
  },
]);

const handleMenuItemClick = item => {
  emit('executeCopilotAction', item.key);
};
</script>

<template>
  <DropdownBody class="min-w-56 [&>ul]:gap-3 z-50 [&>ul]:px-4 [&>ul]:py-3.5">
    <div class="flex flex-col items-start gap-3">
      <Button
        v-for="item in menuItems"
        :key="item.key"
        :label="item.label"
        :icon="item.icon"
        slate
        link
        sm
        class="hover:!no-underline text-n-slate-12 font-normal text-xs w-full !justify-start"
        @click="handleMenuItemClick(item)"
      />
    </div>
  </DropdownBody>
</template>
